import PropTypes from "prop-types"
import React from "react"
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <p>{children}</p>
  }
};

const RichText = ({ content }) => (
  <div>
    {documentToReactComponents(
      content.json,
      options
    )}
  </div>
)

RichText.propTypes = {
  content: PropTypes.object,
}

RichText.defaultProps = {
  content: { json: {}},
}

export default RichText
